/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ClaimTypeEnum {
    Installment = 'INSTALLMENT',
    Principal = 'PRINCIPAL',
    Interest = 'INTEREST',
    LiquidationInterest = 'LIQUIDATION_INTEREST',
    Interest90Plus = 'INTEREST_90_PLUS',
    Rent = 'RENT',
    HousingFees = 'HOUSING_FEES',
    NonpayingFine = 'NONPAYING_FINE',
    BlockageAgreementFine = 'BLOCKAGE_AGREEMENT_FINE',
    NotarialDeedFine = 'NOTARIAL_DEED_FINE',
    NoticeFee = 'NOTICE_FEE',
    EarlyRepaymentFee = 'EARLY_REPAYMENT_FEE',
    StatutoryInterestOnLatePrincipal = 'STATUTORY_INTEREST_ON_LATE_PRINCIPAL',
    StatutoryInterestOnLateInterest = 'STATUTORY_INTEREST_ON_LATE_INTEREST',
    StatutoryInterestOnLateNonpayingFine = 'STATUTORY_INTEREST_ON_LATE_NONPAYING_FINE',
    StatutoryInterestOnLateBlockageAgreementFine = 'STATUTORY_INTEREST_ON_LATE_BLOCKAGE_AGREEMENT_FINE',
    StatutoryInterestOnLateNotarialDeedFine = 'STATUTORY_INTEREST_ON_LATE_NOTARIAL_DEED_FINE'
}

export function ClaimTypeEnumFromJSON(json: any): ClaimTypeEnum {
    return ClaimTypeEnumFromJSONTyped(json, false);
}

export function ClaimTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTypeEnum {
    return json as ClaimTypeEnum;
}

export function ClaimTypeEnumToJSON(value?: ClaimTypeEnum | null): any {
    return value as any;
}

